const workFlowDetailTransformer = data => {
  let defineWorkFlow = {
    workflowType: data?.type,
    workflowName: data?.name,
    trigger: data?.entity || "lead",
    triggerAction: data?.triggerAction || "share_with_mortgage",
    complete: data?.type && data?.name,
    disabled: data?.type && data?.name, // if definition is complete then it cannot be further changed.
    visibleToAll: data?.sharedWithAllDepts,
    ...(!data?.sharedWithAllDepts && { departments: data?.teamTypeIds?.split(",") }),
  }

  let requestInitiation = {
    description: data?.initiationData?.description,
    requiredFields: transformConfigOptions(data?.initiationData?.inputs),
    workflowType: data?.type,
    isLinkedWithEntity: data?.initiationData?.isLinkedWithEntity || false,
    ...(data?.initiationData?.isLinkedWithEntity && { fieldType: data?.initiationData?.fieldType }),
    complete: data?.initiationData?.description && data?.initiationData?.inputs && data?.type,
  }

  let stagesData = data?.stageData?.map(item => ({
    ...item.assignee,
    ...item.config,
    ...item,
    allowBackStage: String(item?.config?.allowBackStage),
    skippable: String(item?.config?.skippable),
    allowTermination: String(item?.config?.allowTermination),
    autoAssign: String(item?.assignee?.autoAssignToTeam),
    department: item?.assignee?.departmentId != null ? String(item?.assignee?.departmentId) : undefined,
    designation: String(item?.assignee?.designationId),
    region: item?.assignee?.regionId != null ? String(item?.assignee?.regionId) : undefined,
    staffId: String(item?.assignee?.staffId),
    requiredFields: transformConfigOptions(item?.inputs),
    filled: true,
    assignTo: item?.assignee?.assignToPreviousStageAssignee
      ? "previous_assignee"
      : item?.assignee?.assignToRequestInitiator
      ? "request_initiator"
      : item?.assignee?.assignToLeadAllocatedUser
      ?   "allocated_user"
      : item?.assignee?.assignToLeadSharedWithUser
      ? "shared_user"
      : "specific_user",
    sharedWithUser: item?.assignee?.leadSharedWithTeamType,
    excludeTeamDesignations: item?.assignee?.excludeTeamDesignations?.split(","),
    showExclude: !!item?.assignee?.excludeTeamDesignations,
  }))

  let stages = {
    complete: data?.stageData?.length > 0,
    stages: stagesData?.length ? stagesData : [{}],
  }

  return { defineWorkFlow, requestInitiation, stages, ...data }
}

let transformConfigOptions = data => {
  data?.forEach(item => {
    if (item?.config?.options) {
      item.config.options = item.config.options?.map(item => item.value)
    }
  })
  return data
}

export default workFlowDetailTransformer
